import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { getOrderbook, getRecentHistory } from 'api/v1/orderbook'
import { SymbolName } from 'types'
import { formatOrderbookMessage } from 'utils/orderbook/order'
import { TradingViewKLintType } from './reducer'
import { OrderbookData, ShowListType, Tick } from './types'
import { WsOrderbookData } from '../../ws/zkex/messages/orderbook'
import { OrderDirection } from 'store/spot/types'
import { v4 } from 'uuid'

export const clearOrderBook = createAction('orderbook/clearOrderBook')
export const updateCurrentChartTab = createAction<TradingViewKLintType>(
  'orderbook/updateCurrentChartTab',
)
export const updateBinanceLastBar = createAction<any>(
  '/orderbook/updateBinanceLastBar',
)
export const updateBinanceTimeConnect = createAction<number>(
  '/orderbook/updateBinanceTimeConnect',
)
export const updateHideOtherPairs = createAction<boolean>(
  'orderbook/updateHideOtherPairs',
)
export const updateResolution = createAction<string>(
  'orderbook/updateResolution',
)

export const updateChartType = createAction<number>('orderbook/updateChartType')
export const getOrderbookAction = createAsyncThunk<
  OrderbookData | undefined,
  SymbolName
>('orderbook/getOrderbook', async (symbolName) => {
  if (!symbolName) {
    return undefined
  }
  const r = await getOrderbook(symbolName)
  const { buyOrders, sellOrders } = r.data

  return {
    ...r.data,
    buyOrders: formatOrderbookMessage(buyOrders),
    sellOrders: formatOrderbookMessage(sellOrders),
  }
})
export const clearOrderbookAction = createAction(
  'orderbook/clearOrderbookAction',
)
export const updateOrderbookPrecisionAction = createAction<string>(
  'orderbook/updateOrderbookPrecisionAction',
)
export const updateShowListType = createAction<ShowListType>(
  'orderbook/updateShowListType',
)
export const updateOrderbook = createAction<OrderbookData>(
  'orderbook/updateOrderbook',
)
export const incrementalOrderbookAction = createAction<WsOrderbookData>(
  'orderbook/incrementalOrderbook',
)

export const updateFavoriteResloution = createAction<{
  type: string
  value: string
}>('orderbook/updateFavoriteResloution')

export const unshiftTickAction = createAction<{
  symbolName: SymbolName
  list: Tick[]
}>('orderbook/unshiftTickAction')

export const getRecentHistoryAction = createAsyncThunk<
  { symbolName: SymbolName; list: Tick[] } | undefined,
  SymbolName
>('orderbook/getRecentHistoryAction', async (symbolName) => {
  if (!symbolName) {
    return undefined
  }

  const r = await getRecentHistory(symbolName)
  const sourceList = r.data[symbolName]

  const list: Tick[] = []

  sourceList.forEach((series) => {
    JSON.parse(series).forEach((item: any[]) => {
      list.push({
        key: v4(),
        symbol: symbolName,
        timestamp: item[0],
        direction: item[1] === 0 ? OrderDirection.SHORT : OrderDirection.LONG,
        price: item[2],
        quantity: item[3],
        volume: item[4],
        flag: item[5],
      })
    })
  })

  list.sort((a, b) => b.timestamp - a.timestamp)

  return { symbolName, list }
})
